import React, { Component } from "react";

import Notificacao from "../../components/Notificacao";

import moment from "moment";
import { getLoggedInUser } from "../../helpers/authUtils";
import {
  firebaseAuth,
  firebaseFire as Libfirebase,
  firebaseStorage
} from "../../helpers/firebase-config";
import Resposta from "../Resposta";

import ComentarioContent from './coment';

// import { Container } from './styles';

export default class Comentario extends Component {
  componentDidMount() {

    const { idPaciente, comentario } = this.props;


  }
  componentWillUnmount() {
    this.forceUpdate();

  }

  state = {
    isVisible: false,
    resposta: "",
    dataProf: "",
    vb: false,
    addComent: false
  };

  _setVisibility = (ev) => {

    this.setState({ vb: !this.state.vb });
    //this.state.vb = !this.state.vb;    

  };

  _responderVis = (ev) => {
    this.setState({ addComent: !this.state.addComent });
  }

  handleChange = event => {
    this.setState({ resposta: event.target.value });
  };

  render() {

    const { idPaciente, idHistorico } = this.props;
    const { dataProf } = this.state;
    return (
      <div>
        <div className="row" style={{ marginTop: 20 }}>
          <div className="col-sm-12"
            style={{
              backgroundColor: '#f5f5f5',
              fontSize: '19px',
              padding: '14px'
            }}
          >
            <i className="far fa-comments"></i> Todos os Comentários
          </div>


          {this.state.addComent
            ?
            (
              <div className="col-sm-12"
                style={{
                  border: '1px solid #f2f2f2',
                  padding: '16px'
                }}
              >
                <h4>Novo comentário</h4>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Comentário..."
                  onChange={e => this.props._setStateComentario(e.target.value)}
                  value={this.props.Txtcomentario}
                />
                <br />
                <button
                  style={{ float: "right" }}
                  onClick={(ev) => { this.props._setComentario(); this._responderVis(ev) }}
                  type="button"
                  className="btn waves-effect waves-light btn-info"
                >
                  Comentar <i className="fas fa-paper-plane"></i>
                </button>
                <br />
                <br />
              </div>
            ) : null}

        </div>
        <div className="col-sm-12" style={{
          padding: 0,
          paddingLeft: '1px',
          paddingRight: '1px',
          marginBottom: '20px'
        }}>
          {this.props.comentario
            ? this.props.comentario.map((coment, index) => {
              
              return (
                <ComentarioContent
                  idComentario={coment.id}
                  idPaciente={this.props.idPaciente}
                  idHistorico={this.props.idHistorico}
                  historico={this.props.historico}
                  comentario={this.state.comentario}
                  usuario={this.props.usuario}
                  _setComentario={(comentario) => this.props._setComentario(this.props.usuario, coment.id, comentario)}
                  _setResposta={() => {
                    this._setResposta(coment.id, this.props.idHistorico, this.props.idPaciente)
                  }}
                  update={() => this.props.update()}
                  Txtcomentario={this.state.comentario}
                  coment={coment}
                  index={index}
                  key={index}
                  objPai={this.props.objPai}
                  setRespostaTo={(ev) => this.props.setRespostaTo(ev)}
                  referencia={coment.referencia}
                />

              );
            })
            : (
              <div style={{width:'100%', padding:'20px', textAlign:'center', color:'#d3d3d3'}}>
                <i className="fas fa-comment-slash"></i>
                {' '}
                <p>Nenhum comentário adicionado ainda.
                  <br /><i><b>Adicione um novo comentário agora mesmo utilizando o campo abaixo</b></i>
                </p>
                </div>

            )}
        </div>
        <div className="row p-6">
          <div className="col-sm-2 text-right">

          </div>
          <div className="col-sm-8">
            <input type="text"
              className="form-control"
              rows="3"
              placeholder="Digite o seu comentário..."
              onChange={e => this.props._setStateComentario(e.target.value)}
              value={this.props.Txtcomentario}
              style={{
                display: 'inline-block',
                width: '80%',
                borderRight: 'none'
              }}
            />

            <button
              style={{
                display: 'inline-block',
                height: '38px',
                marginTop: '-2px',
                marginLeft: '-2px'
              }}
              onClick={(ev) => { this.props._setComentario(); }}
              type="button"
              className="btn waves-effect waves-light btn-secondary btn-sm"
            >
              Comentar <i className="fas fa-paper-plane"></i>
            </button>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-2" style={{ maxWidth: "23%" }}>
            {this.props.usuario ? (
              this.props.usuario.photoURL ? (
                <img
                  className="rounded-circle img-fluid"
                  src={this.props.usuario.photoURL}
                />
              ) : (
                  <img
                    className="img-fluid"
                    src="data:image/png;base64,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"
                  />
                )
            ) : null}
          </div>

          <div className="col-sm-10" style={{ maxWidth: "76%" }}>

          </div>
        </div>
      </div>
    );
  }
}
